import { removeInitialContent } from "@escapio/shared/components/element-builder";
import { html, render } from "lit-html";
import connect from "../../../shared/data-store/connect";
import { store } from "./DataStore";

customElements.define(
	"esc-hotel-list-header-counter",
	class extends connect(removeInitialContent(HTMLElement), store) {
		update(state, { counters }) {
			const count = counters.direct;
			const renderedCount = html`<strong>${count}</strong>`;
			const headline =
				count === 1
					? this.getAttribute("translation-singular")
					: this.getAttribute("translation-plural");

			const headlineParts = headline.split("%Hotelanzahl%");
			const headlineLastPart = headlineParts.pop();

			const template = [
				...headlineParts.map(part => [part, renderedCount]),
				headlineLastPart,
			];

			render(template, this);
		}
	},
);
